import FormCritica from './FormCritica'

export default FormCritica;